import { camelCase } from '../util.js'

var works = [
  {
    title: '2019年新春营销，幸福吧我的家系列稿',
    desc: '2019年新春营销，幸福吧我的家系列稿',
    thumb: camelCase('cases-brand-chinamobile-0'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-01'),
      camelCase('cases-brand-chinamobile-lazyload-02'),
      camelCase('cases-brand-chinamobile-lazyload-03'),
      camelCase('cases-brand-chinamobile-lazyload-04'),
      camelCase('cases-brand-chinamobile-lazyload-05')
    ]
  },
  {
    title: '第五届互联网大会效果图',
    desc: '第五届互联网大会效果图',
    thumb: camelCase('cases-brand-chinamobile-1'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-11'),
      camelCase('cases-brand-chinamobile-lazyload-12'),
      camelCase('cases-brand-chinamobile-lazyload-13'),
      camelCase('cases-brand-chinamobile-lazyload-14'),
      camelCase('cases-brand-chinamobile-lazyload-15')
    ]
  },
  {
    title: '地铁包装',
    desc: '地铁包装',
    thumb: camelCase('cases-brand-chinamobile-2'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-21'),
      camelCase('cases-brand-chinamobile-lazyload-22'),
      camelCase('cases-brand-chinamobile-lazyload-23'),
      camelCase('cases-brand-chinamobile-lazyload-24')
    ]
  },
  {
    title: '出行KV',
    desc: '出行KV',
    thumb: camelCase('cases-brand-chinamobile-3'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-31')
    ]
  },
  {
    title: '感恩充值送活动宣传KV',
    desc: '感恩充值送活动宣传KV',
    thumb: camelCase('cases-brand-chinamobile-4'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-41')
    ]
  },
  {
    title: '咪咕爱看会员宣传KV-打破门槛',
    desc: '咪咕爱看会员宣传KV-打破门槛',
    thumb: camelCase('cases-brand-chinamobile-5'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-51')
    ]
  },
  {
    title: '五一节点',
    desc: '五一节点',
    thumb: camelCase('cases-brand-chinamobile-6'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-61'),
      camelCase('cases-brand-chinamobile-lazyload-62'),
      camelCase('cases-brand-chinamobile-lazyload-63')
    ]
  },
  {
    title: '感恩充值送活动宣传KV',
    desc: '感恩充值送活动宣传KV',
    thumb: camelCase('cases-brand-chinamobile-7'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-71')
    ]
  },
  {
    title: '咪咕爱看会员宣传KV-熊猫VIP',
    desc: '咪咕爱看会员宣传KV-熊猫VIP',
    thumb: camelCase('cases-brand-chinamobile-8'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-81')
    ]
  },
  {
    title: '元旦小改变',
    desc: '元旦小改变',
    thumb: camelCase('cases-brand-chinamobile-9'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-91'),
      camelCase('cases-brand-chinamobile-lazyload-92'),
      camelCase('cases-brand-chinamobile-lazyload-93')
    ]
  },
  {
    title: '咪咕爱看红包活动宣传',
    desc: '咪咕爱看红包活动宣传',
    thumb: camelCase('cases-brand-chinamobile-10'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-101')
    ]
  },
  {
    title: '头条抖音包-海报',
    desc: '头条抖音包-海报',
    thumb: camelCase('cases-brand-chinamobile-11'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-111')
    ]
  },
  {
    title: '刷和包得流量Gif',
    desc: '刷和包得流量Gif',
    thumb: camelCase('cases-brand-chinamobile-12'),
    zpic: [
      require('../../assets/cases-brand-chinamobile-lazyload-121.mp4')
    ]
  },
  {
    title: '中国移动和包支付3分钟',
    desc: '中国移动和包支付3分钟',
    thumb: camelCase('cases-brand-chinamobile-13'),
    zpic: [
      require('../../assets/cases-brand-chinamobile-lazyload-131.mp4')
    ]
  },
  {
    title: '咪咕爱看&宽带电视双屏互动功能介绍视频',
    desc: '咪咕爱看&宽带电视双屏互动功能介绍视频',
    thumb: camelCase('cases-brand-chinamobile-14'),
    zpic: [
      require('../../assets/cases-brand-chinamobile-lazyload-141.mp4')
    ]
  },
  {
    title: '浙江移动小象卡业务',
    desc: '浙江移动小象卡业务',
    thumb: camelCase('cases-brand-chinamobile-15'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-151')
    ]
  },
  {
    title: '内外层小象',
    desc: '内外层小象',
    thumb: camelCase('cases-brand-chinamobile-16'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-161'),
      camelCase('cases-brand-chinamobile-lazyload-162')
    ]
  },
  {
    title: '端午节',
    desc: '端午节',
    thumb: camelCase('cases-brand-chinamobile-17'),
    zpic: [
      camelCase('cases-brand-chinamobile-lazyload-171'),
      camelCase('cases-brand-chinamobile-lazyload-172')
    ]
  }
]

export default {
  name: '中国移动',
  logo: {
    default: camelCase('cases-brand-1'),
    active: camelCase('cases-brand-1-cover')
  },
  works
}
